export default (params) => ({
  trigger: {
    name: 'product_specifications.search',
    params: params,
  },
  config: {
    schema: {
      search_term: {
        type: 'string',
      },
    },
    event: {
      name: 'search',
      params: {
        sub_feature: 'specifications',
        method: 'typing',
      },
    },
  },
});
